export default theme => ({
  data: {
    marginTop: theme.sizes[3],
  },
  highlightedLink: {
    color: theme.palette.link.dark + " !important"
  }
});
